@import '../../../../../../../constants/spacing.module.less';

.content-wrapper {
  display: flex;
  gap: @space-16;
  justify-content: space-between;
}

.counter {
  color: var(--grey-600);
}
